let baseUrl = "";
let Appid = "";
Appid = 'wx1700ae4a85640f10';
export default {
    baseUrl,
    Appid
}